import { useEffect, useMemo, useState } from 'react';

import { useGetAsignmentFieldsQuery } from 'services';
import { afterCopyrightStatus } from 'utils';

function useStepController({ type, offerID, offerStatus, currentUserID, isAdmin, disabledStatus }) {
  const { data: assignments, isLoading } = useGetAsignmentFieldsQuery({
    type: type,
    articleOffer: offerID,
  });
  const [current, setCurrent] = useState(0);

  const handleCurrentIndex = (index) => {
    setCurrent(index);
  };

  const currentIndex = useMemo(() => assignments?.findIndex((step) => step.status === offerStatus), [assignments, offerStatus]);
  const selectedItemStatus = useMemo(() => assignments?.[current - 1]?.status, [assignments, current]);

  /**
   * kullancinin karar verip veremedigi de step ile alakali oldugu icin step controller icinde kontrol edilir
   * @todo BE ile konusulacak bundan daha saglikli bir kontrol mumkun mu diye bakilacak
   */
  const userCanDecide = useMemo(() => {
    return assignments?.[current - 1]?.assignments?.some((assignment) => assignment.user.id === currentUserID) || isAdmin;
  }, [current, currentUserID, isAdmin, assignments]);

  useEffect(() => {
    handleCurrentIndex(currentIndex + 1);
  }, [currentIndex, offerStatus]);

  const afterCopyrightSteps = [
    {
      id: crypto.randomUUID(),
      title: afterCopyrightStatus[disabledStatus],
      style: { cursor: 'pointer' },
    },
    ...(assignments?.map((step, index) => {
      return {
        id: index,
        title: (
          <div>
            {step.roleText}
            <br />
            <small>{step.assignments[0]?.user?.fullName}</small>
          </div>
        ),
        disabled: step.assignments[0]?.opinion === 'created',
      };
    }) || []),
  ];

  return { current, selectedItemStatus, isLoading, handleCurrentIndex, currentIndex, userCanDecide, afterCopyrightSteps };
}

export default useStepController;
